import { render, staticRenderFns } from "./testQuestionManagement.vue?vue&type=template&id=3b4c2709&scoped=true&"
import script from "./testQuestionManagement.vue?vue&type=script&lang=js&"
export * from "./testQuestionManagement.vue?vue&type=script&lang=js&"
import style0 from "./testQuestionManagement.vue?vue&type=style&index=0&id=3b4c2709&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4c2709",
  null
  
)

export default component.exports